import { render } from "./ConnectionOverlay.vue?vue&type=template&id=34a5321f&scoped=true"
import script from "./ConnectionOverlay.vue?vue&type=script&lang=js"
export * from "./ConnectionOverlay.vue?vue&type=script&lang=js"

import "./ConnectionOverlay.vue?vue&type=style&index=0&id=34a5321f&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a5321f"]])

export default __exports__